import externalPartnerRequests from '@/http/requests/external-partner'

const { partnerAdminRequests } = externalPartnerRequests

export default {
  fetchPartners: ({ commit }, query = {}) => new Promise((resolve, reject) => {
    partnerAdminRequests.getPartners(query)
      .then(response => {
        commit('SET_PARTNERS', response.data)
        resolve(response)
      })
      .catch(error => reject(error))
  }),

  fetchPartnerById: ({ commit }, id) => new Promise((resolve, reject) => {
    partnerAdminRequests.getPartnerById(id)
      .then(response => {
        commit('SET_PARTNER', response.data)
        resolve(response)
      })
      .catch(error => reject(error))
  }),

  createPartner: (_, payload) => new Promise((resolve, reject) => {
    partnerAdminRequests.createPartner(payload)
      .then(response => resolve(response))
      .catch(error => reject(error))
  }),

  updatePartner: ({ commit }, payload) => new Promise((resolve, reject) => {
    partnerAdminRequests.updatePartner(payload.id, payload.data)
      .then(response => {
        commit('SET_PARTNER', response.data)
        resolve(response)
      })
      .catch(error => reject(error))
  }),

  deletePartner: (_, id) => new Promise((resolve, reject) => {
    partnerAdminRequests.deletePartner(id)
      .then(response => resolve(response))
      .catch(error => reject(error))
  }),

  fetchAssignedUsers: ({ commit }, payload) => new Promise((resolve, reject) => {
    partnerAdminRequests.getPartnerUsers(payload.partnerId, payload.query || {})
      .then(response => {
        commit('SET_ASSIGNED_USERS', response.data)
        resolve(response)
      })
      .catch(error => reject(error))
  }),

  fetchAssignableUsers: ({ commit }, query = {}) => new Promise((resolve, reject) => {
    partnerAdminRequests.getAssignableUsers(query)
      .then(response => {
        commit('SET_ASSIGNABLE_USERS', response.data)
        resolve(response)
      })
      .catch(error => reject(error))
  }),

  assignUserToPartner: (_, payload) => new Promise((resolve, reject) => {
    partnerAdminRequests.assignUserToPartner(payload.partnerId, payload.data)
      .then(response => resolve(response))
      .catch(error => reject(error))
  }),

  unassignUserFromPartner: (_, payload) => new Promise((resolve, reject) => {
    partnerAdminRequests.unassignUserFromPartner(payload.partnerId, payload.userId)
      .then(response => resolve(response))
      .catch(error => reject(error))
  }),

  fetchPartnerCustomerMappings: ({ commit }, payload) => new Promise((resolve, reject) => {
    partnerAdminRequests.getPartnerCustomerMappings(payload.partnerId, payload.query || {})
      .then(response => {
        commit('SET_CUSTOMER_MAPPINGS', response.data)
        resolve(response)
      })
      .catch(error => reject(error))
  }),

  fetchCustomersLookup: ({ commit }, query = {}) => new Promise((resolve, reject) => {
    partnerAdminRequests.getCustomersLookup(query)
      .then(response => {
        commit('SET_CUSTOMERS_LOOKUP', response.data)
        resolve(response)
      })
      .catch(error => reject(error))
  }),

  createPartnerCustomerMapping: (_, payload) => new Promise((resolve, reject) => {
    partnerAdminRequests.createPartnerCustomerMapping(payload.partnerId, payload.data)
      .then(response => resolve(response))
      .catch(error => reject(error))
  }),

  updatePartnerCustomerMapping: (_, payload) => new Promise((resolve, reject) => {
    partnerAdminRequests.updatePartnerCustomerMapping(payload.partnerId, payload.mappingId, payload.data)
      .then(response => resolve(response))
      .catch(error => reject(error))
  }),

  deletePartnerCustomerMapping: (_, payload) => new Promise((resolve, reject) => {
    partnerAdminRequests.deletePartnerCustomerMapping(payload.partnerId, payload.mappingId)
      .then(response => resolve(response))
      .catch(error => reject(error))
  }),
}
